"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const removeSessionCookie_1 = __importDefault(require("../../utils/login/removeSessionCookie"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**  start-no-seo */
const customerDriver_store_1 = __importDefault(require("./customerDriver.store")); // no-seo
const customerDriverDocument_store_1 = __importDefault(require("./customerDriverDocument.store")); // no-seo
const customerFind_store_1 = __importDefault(require("./customerFind.store")); // no-seo
const customerForgotPwd_store_1 = __importDefault(require("./customerForgotPwd.store")); // no-seo
/** end-no-seo */
const customerLogin_store_1 = __importDefault(require("./customerLogin.store"));
/**  start-no-seo */
const customerProfile_store_1 = __importDefault(require("./customerProfile.store")); // no-seo
const customerProfileUpdate_store_1 = __importDefault(require("./customerProfileUpdate.store")); // no-seo
/** end-no-seo */
const customerRegister_store_1 = __importDefault(require("./customerRegister.store"));
/**  start-no-seo */
const customerSaveCard_store_1 = __importDefault(require("./customerSaveCard.store")); // no-seo
/** end-no-seo */
/**  start-no-seo */
const documentUpload_store_1 = __importDefault(require("./documentUpload.store")); // no-seo
const generateOtp_store_1 = __importDefault(require("./generateOtp.store")); // no-seo
const generateOtpForgotPwd_store_1 = __importDefault(require("./generateOtpForgotPwd.store")); // no-seo
const verifyOtp_store_1 = __importDefault(require("./verifyOtp.store")); // no-seo
/** end-no-seo */
/**
 * Account Page Store
 * Consumes CustomerFind, GenerateOtp, VerifyOtp, CustomerLogin, CustomerRegister, CustomerProfie
 * Maintains Account Page related data and state
 */
class AccountPageStore {
    /** end-no-seo */
    constructor(initialState = {}, $env) {
        this.data = {};
        /**
         * Action to update state when user is unauthorized
         * He might have deleted the cookie manually
         * Or he has tampered it
         * Or the cookie expired
         */
        this.setUnAuthorized = () => {
            // update local observable
            this.data = {
                isLoggedIn: false,
                sessionToken: null,
            };
            // update login & registration stores
            // since they might have stored data
            this.customerLogin.setUnAuthorized();
            this.customerRegister.setUnAuthorized();
            // clear customerDriver store on signout.
            this.customerDriver.onSignout();
            // clear documentUpload store on signout.
            this.documentUpload.onSignout();
            // clear customerProfile store on signout.
            this.customerProfile.onSignout();
            // remove session cookie
            (0, removeSessionCookie_1.default)();
        };
        /** end-no-seo */
        /**
         * Action to logout user
         */
        this.logout = (onSuccess, onError) => {
            try {
                // remove session cookie
                (0, removeSessionCookie_1.default)();
                /**  start-no-seo */
                // nullify stores
                this.setUnAuthorized();
                /** end-no-seo */
                // invoke callback if any
                if (onSuccess) {
                    onSuccess();
                }
            }
            catch (err) {
                if (onError) {
                    onError(err);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
        // initialize domain stores
        this.customerRegister = new customerRegister_store_1.default(initialState.customerRegister, $env);
        this.customerLogin = new customerLogin_store_1.default(initialState.customerLogin, $env);
        /**  start-no-seo */
        this.customerFind = new customerFind_store_1.default(initialState.customerFind);
        this.generateOtp = new generateOtp_store_1.default(initialState.generateOtp);
        this.verifyOtp = new verifyOtp_store_1.default(initialState.verifyOtp);
        this.customerProfile = new customerProfile_store_1.default(initialState.customerProfile);
        this.customerDriver = new customerDriver_store_1.default(initialState.customerDriver, $env);
        this.customerDriverDocument = new customerDriverDocument_store_1.default();
        this.documentUpload = new documentUpload_store_1.default(initialState.documentUpload);
        this.customerProfileUpdate = new customerProfileUpdate_store_1.default(initialState.customerProfileUpdate);
        this.generateOtpForgotPwd = new generateOtpForgotPwd_store_1.default(initialState.generateOtpForgotPwd);
        this.customerForgotPwd = new customerForgotPwd_store_1.default(initialState.customerForgotPwd);
        this.customerSaveCard = new customerSaveCard_store_1.default();
        /** end-no-seo */
    }
    /**
     * Returns current config language
     * @returns {Boolean}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**
     * Returns true if user is logged in
     * checks inside observable or login store or registration store
     */
    get isLoggedIn() {
        return ((0, get_1.default)(this.data, 'isLoggedIn', false) ||
            (0, get_1.default)(this.customerLogin, 'isLoginSuccess', false) ||
            (0, get_1.default)(this.customerRegister, 'isRegistrationSuccess', false));
    }
    /**  start-no-seo */
    /**
     * Returns user session cookie token
     * checks inside observable or login store or registration store
     */
    get sessionToken() {
        return ((0, get_1.default)(this.data, 'sessionToken', null) ||
            (0, get_1.default)(this.customerLogin, 'sessionToken', null) ||
            (0, get_1.default)(this.customerRegister, 'sessionToken', null));
    }
}
__decorate([
    mobx_1.observable
], AccountPageStore.prototype, "data", void 0);
__decorate([
    mobx_1.computed
], AccountPageStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], AccountPageStore.prototype, "isLoggedIn", null);
__decorate([
    mobx_1.computed
], AccountPageStore.prototype, "sessionToken", null);
__decorate([
    mobx_1.action.bound
], AccountPageStore.prototype, "setUnAuthorized", void 0);
__decorate([
    mobx_1.action.bound
], AccountPageStore.prototype, "logout", void 0);
__decorate([
    mobx_1.action.bound
], AccountPageStore.prototype, "updateInitialState", void 0);
exports.default = AccountPageStore;
